<template>
  <div class="popup">
    <a class="close-x" @click="cancelDelete">
      <img class="close-icon" src="@/assets/images/close_icon.svg" alt="">
    </a>
    <section class="content">
      <h1 class="title">
       {{ $t('DELETE_CONTENT_CONFIRMATION') }}
      </h1>
      <div class="delete-animation">
          <div class="delete-animation-inner">
            <div class="trash-cover">
              <img src="@/assets/images/trash_cover.svg" alt="">
            </div>
            <div class="trash-body">
              <img src="@/assets/images/trash_body.svg" alt="">
            </div>
          </div>
      </div>
    </section>
    <footer class="success-purchase-footer">
      <button class="common-button delete-button" @click="deleteSelectedEntry">
         {{ $t('DELETE') }}
      </button>
      <button class="common-button cancel-button" @click="cancelDelete" >
         {{ $t('CANCEL') }}
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'delete-content',
  methods: {
    // calling event to delete selected unit from db
    deleteSelectedEntry () {
      this.$emit('approve-popup-function', { action: 'delete' })
    },
    // call function displayDeleteComponent that will remove this component
    cancelDelete () {
      this.$emit('close-popup')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
